var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { IconButton } from '@mui/material';
import { ErrorMessage, Field, Formik } from 'formik';
import { useStore } from 'react-context-hook';
import { AiFillDelete } from 'react-icons/ai';
import { BsArrowLeft, BsArrowRight, BsCameraFill, BsEmojiFrownFill, BsEmojiSmileFill, BsEnvelope, BsLockFill, } from 'react-icons/bs';
import { useParams } from 'react-router-dom';
import { Col, Row } from 'react-styled-flexboxgrid';
import * as yup from 'yup';
import { RoundLogo } from '@app/components/atm.logo/logo.component';
import { useFlashMessage } from '@app/components/obj.flash-message';
import { axiosClient } from '@app/configure-app';
import { GoogleBusinessRedirectModal } from '@app/modules/nps/avaliation/redirect-google-business';
import { ExternalQuestionnaireComponent } from '@app/modules/questionnarie/external/external-questionnaire.component';
import { CustomerInfo } from '@app/modules/quiz/components/phase-completed/components/avaliation-modal/avaliation-modal.styled';
import { getUserLocation } from '@app/services/location';
// import { convertFileToBase64 } from '@app/utils/shared-functions.utils';
import { convertFileToBase64 } from '@app/utils/shared-functions.utils';
import { CheckboxField, FlashMessageEnum, TextField } from '@atomic';
import { Switch } from '@atomic/atm.switch';
import { ConfirmationModal } from './confirmation-modal.tsx/confirmation-modal';
import { marks } from './nps-marks';
import { BrandDots, CommentCounter, CommentField, CommentLabel, ConsentCheckbox, ContactFields, DecorativeShape, FooterLine, GradientSlider, HiddenFileInput, Link, LinkedImage, NpsCard, NpsContent, NpsFooter, NpsLinkArea, NpsPageWrapper, NpsSubtitle, NpsTitle, OptionDescription, OptionIcon, OptionRow, OptionText, OptionTitle, PhotoButton, PhotoPreview, QuestionSupport, QuestionTitle, Scale, ScaleEnd, ScaleEnds, ScaleItem, SectionDivider, SliderArea, SliderHint, StyledErrorMessageWrapper, SubmitButton, SubmitContent, UnidadeNome, } from './styles';
export var NPS = function (_a) {
    var _b, _c, _d;
    var logo = _a.logo, unidadeEmpresa = _a.unidadeEmpresa;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var commentMaxLength = 500;
    var _e = useStore('nps', false), _ = _e[0], setNps = _e[1];
    var company = useStore('company')[0];
    var id = useParams().id;
    var _f = React.useState(5), avaliacaoValue = _f[0], setAvaliacaoValue = _f[1];
    var _g = React.useState(''), comment = _g[0], setComment = _g[1];
    var _h = React.useState(false), isUserInfoFilled = _h[0], setUserInfoFilled = _h[1];
    var _j = React.useState(false), realizouAvaliacao = _j[0], setRealizouAvaliacao = _j[1];
    var _k = React.useState(undefined), coordenadas = _k[0], setCoordenadas = _k[1];
    var _l = React.useState(undefined), userAgent = _l[0], setUserAgent = _l[1];
    var _m = React.useState(undefined), file = _m[0], setFile = _m[1];
    var _o = React.useState(null), fileBase64 = _o[0], setFileBase64 = _o[1];
    var _p = React.useState(true), lgpd = _p[0], setLgpd = _p[1];
    var _q = React.useState(false), openGoogleBusinessModal = _q[0], setOpenGoogleBusinessModal = _q[1];
    var _r = React.useState(undefined), npsId = _r[0], setNpsId = _r[1];
    var _s = React.useState(false), isLoading = _s[0], setIsLoading = _s[1];
    var showFlashMessage = useFlashMessage()[0];
    // NOVOS ESTADOS
    var _t = React.useState(false), showConfirmationModal = _t[0], setShowConfirmationModal = _t[1];
    var _u = React.useState(null), questionarioParaNota = _u[0], setQuestionarioParaNota = _u[1];
    var _v = React.useState(null), dadosSubmetidos = _v[0], setDadosSubmetidos = _v[1];
    var _w = React.useState(false), showQuestionario = _w[0], setShowQuestionario = _w[1];
    var handleImageChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setFile(URL.createObjectURL(event.target.files[0]));
                    _a = setFileBase64;
                    return [4 /*yield*/, convertFileToBase64(event.target.files[0])];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    return [2 /*return*/];
            }
        });
    }); };
    var fileInputRef = React.useRef(null);
    var handleAddImageClick = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var handleDeleteImageClick = function () {
        setFileBase64(null);
        setFile(undefined);
        fileInputRef.current.value = '';
    };
    React.useEffect(function () {
        setUserAgent(window.navigator.userAgent);
        var getLocation = function () { return __awaiter(void 0, void 0, void 0, function () {
            var userCoordenadas, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getUserLocation()];
                    case 1:
                        userCoordenadas = _a.sent();
                        setCoordenadas(userCoordenadas);
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('Error fetching user location:', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        getLocation();
    }, []);
    var handleSubmit = function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
        var response, dados, questionariosConfig, questionarioEncontrado, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isLoading)
                        return [2 /*return*/];
                    setIsLoading(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, axiosClient.post("nps/" + id, {
                            nota: avaliacaoValue,
                            comentario: comment,
                            clienteNome: formValues.nome,
                            clienteEmail: formValues.email,
                            clienteTelefone: formValues.telefone,
                            lgpb: lgpd,
                            coordenadas: coordenadas,
                            userAgent: userAgent,
                            imagem: fileBase64,
                            unidadeEmpresaToken: localStorage.getItem('npsToken'),
                        })];
                case 2:
                    response = _a.sent();
                    localStorage.setItem('npsToken', unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.token);
                    setNpsId(response.data.data);
                    dados = {
                        formValues: formValues,
                        comentario: comment,
                        avaliacaoValue: avaliacaoValue,
                    };
                    setDadosSubmetidos(dados);
                    questionariosConfig = (unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.questionarioEmpresaConfiguracaoNps) || [];
                    questionarioEncontrado = questionariosConfig.find(function (q) { return q.nota === avaliacaoValue; });
                    if (questionarioEncontrado) {
                        // MOSTRAR POPUP DE CONFIRMAÇÃO
                        setQuestionarioParaNota(questionarioEncontrado);
                        setShowConfirmationModal(true);
                    }
                    else {
                        prosseguirFluxoNormal();
                    }
                    return [3 /*break*/, 5];
                case 3:
                    error_2 = _a.sent();
                    console.error('Submission failed:', error_2);
                    localStorage.removeItem('npsToken');
                    return [3 /*break*/, 5];
                case 4:
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    // FUNÇÃO PARA PROSSEGUIR FLUXO NORMAL (Google Business ou Thanks)
    var prosseguirFluxoNormal = function () {
        if (avaliacaoValue >= 9 && (unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.urlGoogleBusiness)) {
            setOpenGoogleBusinessModal(true);
        }
        else {
            setNps(true);
        }
    };
    // FUNÇÃO QUANDO USUÁRIO CONFIRMA RESPONDER QUESTIONÁRIO
    var handleConfirmQuestionario = function () {
        setShowConfirmationModal(false);
        setShowQuestionario(true);
    };
    var handleQuestionarioComplete = function () {
        setShowQuestionario(false);
        prosseguirFluxoNormal(); // Vai para Google Business ou Thanks
    };
    // FUNÇÃO QUANDO USUÁRIO RECUSA QUESTIONÁRIO
    var handleCancelQuestionario = function () {
        setShowConfirmationModal(false);
        prosseguirFluxoNormal();
    };
    var copyToClipboard = function (text) {
        navigator.clipboard
            .writeText(text)
            .then(function () {
            showFlashMessage(FlashMessageEnum.success, 'Avaliação Copiada para area de transferencia.');
        })
            .catch(function (err) {
            showFlashMessage(FlashMessageEnum.alert, 'Erro ao copiar o texto: ' + err);
        });
    };
    var closeGoogleBusinessModal = function () {
        setOpenGoogleBusinessModal(false);
        setNps(true);
    };
    var handleSliderChange = function (event, newValue) {
        setRealizouAvaliacao(true);
        setAvaliacaoValue(newValue);
    };
    var schema = isUserInfoFilled
        ? yup.object({
            nome: yup.string().required('O nome é obrigatório'),
            email: yup.string().email('Email inválido').required('O email é obrigatório'),
            telefone: yup.string().required('O telefone é obrigatório'),
        })
        : yup.string();
    var handleClick = function () {
        if (unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.npsUrl) {
            window.open(unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.npsUrl, '_blank');
        }
    };
    /*
    React.useEffect(() => {
      if (unidadeEmpresa && unidadeEmpresa.questionarioEmpresaConfiguracaoNps.length <= 0) {
        // Mock para teste - questionário para nota 9 (usar id externo solicitado)
        unidadeEmpresa.questionarioEmpresaConfiguracaoNps = [
          {
            id: '53677340-b9be-49c2-987c-657ff5458676',
            nota: 9, // Teste com nota 9
            titulo: 'Pesquisa de Satisfação',
            perguntas: [
              {
                id: 1586,
                titulo: 'O que podemos fazer para melhorar nosso atendimento?',
                ordem: 0,
                tipoPergunta: 2, // Texto
                alternativas: [],
                respostas: [],
                referencia: '',
              },
              {
                id: 1587,
                titulo: 'Qual área precisa de mais atenção?',
                ordem: 1,
                tipoPergunta: 1, // Múltipla escolha
                alternativas: [
                  {
                    id: 2867,
                    ordem: 1,
                    descricao: 'Atendimento ao cliente',
                    etiqueta: null,
                    referencia: null,
                  },
                  {
                    id: 2868,
                    ordem: 2,
                    descricao: 'Qualidade do produto',
                    etiqueta: null,
                    referencia: null,
                  },
                  {
                    id: 2869,
                    ordem: 3,
                    descricao: 'Tempo de resposta',
                    etiqueta: null,
                    referencia: null,
                  },
                ],
                respostas: [],
                referencia: '',
              },
            ],
          },
        ];
      }
    }, [unidadeEmpresa]);
    */
    // quando showQuestionario estiver true mostramos somente o componente externo
    if (showQuestionario) {
        // prioriza questionarioParaNota (definido quando usuário confirma responder),
        // senão busca pelo array de configuração usando a nota selecionada,
        // senão usa o id mock padrão pedido.
        var externalQuestionId = String((_b = questionarioParaNota === null || questionarioParaNota === void 0 ? void 0 : questionarioParaNota.questionarioEmpresaId) !== null && _b !== void 0 ? _b : (_d = (_c = unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.questionarioEmpresaConfiguracaoNps) === null || _c === void 0 ? void 0 : _c.find(function (q) { return q.nota === avaliacaoValue; })) === null || _d === void 0 ? void 0 : _d.questionarioEmpresaId);
        return (React.createElement(ExternalQuestionnaireComponent, { id: externalQuestionId, logo: logo, nome: unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.nome, npsId: npsId, onComplete: function () {
                // esconder questionário e prosseguir fluxo normal (Google Business / Thanks)
                setShowQuestionario(false);
                prosseguirFluxoNormal();
            }, onClose: function () {
                setShowQuestionario(false);
                prosseguirFluxoNormal();
            } }));
    }
    var nomeUnidade = unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.nome;
    var commentHasError = comment.length > commentMaxLength;
    return (React.createElement(NpsPageWrapper, null,
        React.createElement(DecorativeShape, { "$variante": "lilas" }),
        React.createElement(DecorativeShape, { "$variante": "rosa" }),
        React.createElement(ConfirmationModal, { open: showConfirmationModal, onConfirm: handleConfirmQuestionario, onCancel: handleCancelQuestionario }),
        React.createElement(GoogleBusinessRedirectModal, { open: openGoogleBusinessModal, onClose: closeGoogleBusinessModal, urlGoogleBusiness: unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.urlGoogleBusiness, npsId: npsId, comentario: comment }),
        React.createElement(NpsContent, null,
            React.createElement(RoundLogo, { src: logo }),
            React.createElement(NpsTitle, null, "A sua opini\u00E3o \u00E9 muito importante!"),
            React.createElement(NpsSubtitle, null, "Nos ajude a oferecer uma experi\u00EAncia cada vez melhor."),
            ((unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.imagemNpsUrl) || (unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.tituloNpsUrl)) && (React.createElement(NpsLinkArea, null,
                (unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.imagemNpsUrl) && React.createElement(LinkedImage, { src: unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.imagemNpsUrl, onClick: handleClick }),
                (unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.tituloNpsUrl) && React.createElement(Link, { onClick: handleClick }, unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.tituloNpsUrl))),
            React.createElement(NpsCard, null,
                React.createElement(QuestionTitle, null,
                    "Como foi sua experi\u00EAncia hoje",
                    nomeUnidade ? (React.createElement(React.Fragment, null,
                        ' ',
                        "na unidade ",
                        React.createElement(UnidadeNome, null, nomeUnidade),
                        "?")) : (' conosco?')),
                React.createElement(QuestionSupport, null, nomeUnidade
                    ? "De 0 a 10, o quanto voc\u00EA recomendaria a unidade " + nomeUnidade + " para um amigo ou familiar?"
                    : 'De 0 a 10, o quanto você nos recomendaria para um amigo ou familiar?'),
                React.createElement(SliderArea, null,
                    React.createElement(GradientSlider, { "aria-label": "Nota de 0 a 10", onChange: handleSliderChange, value: avaliacaoValue, step: 1, valueLabelDisplay: "on", marks: marks, min: 0, max: 10 })),
                React.createElement(Scale, { "aria-hidden": "true" }, marks.map(function (mark) { return (React.createElement(ScaleItem, { key: mark.value, "$posicao": mark.value * 10, "$ativo": mark.value === avaliacaoValue }, mark.label)); })),
                React.createElement(ScaleEnds, null,
                    React.createElement(ScaleEnd, null,
                        React.createElement(BsEmojiFrownFill, { color: "#ef4444", size: 26 }),
                        "Nada prov\u00E1vel"),
                    React.createElement(ScaleEnd, null,
                        "Muito prov\u00E1vel",
                        React.createElement(BsEmojiSmileFill, { color: "#22a355", size: 26 }))),
                React.createElement(SliderHint, null,
                    React.createElement(BsArrowLeft, null),
                    " Deslize para escolher sua nota ",
                    React.createElement(BsArrowRight, null)),
                realizouAvaliacao && (React.createElement(React.Fragment, null,
                    React.createElement(SectionDivider, null),
                    React.createElement(CommentLabel, { htmlFor: "nps-comentario" }, "Deixe seu elogio, cr\u00EDtica ou coment\u00E1rio"),
                    React.createElement(CommentField, { id: "nps-comentario", placeholder: "Em que podemos melhorar?", "$erro": commentHasError, onChange: function (e) {
                            var inputValue = e.target.value;
                            setComment(inputValue);
                        } }),
                    React.createElement(CommentCounter, { style: { color: commentHasError ? 'red' : '' } },
                        comment.length,
                        "/",
                        commentMaxLength))),
                React.createElement(Formik, { initialValues: { nome: '', telefone: '', email: '' }, enableReinitialize: true, onSubmit: handleSubmit, validationSchema: schema }, function (_a) {
                    var setFieldValue = _a.setFieldValue, errors = _a.errors;
                    return (React.createElement(CustomerInfo, null,
                        React.createElement(SectionDivider, null),
                        React.createElement(OptionRow, { "$destaque": true },
                            React.createElement(OptionIcon, { "$destaque": true },
                                React.createElement(BsCameraFill, { size: 22 })),
                            React.createElement(OptionText, null,
                                React.createElement(OptionTitle, null, "Quer adicionar uma foto?"),
                                React.createElement(OptionDescription, null, "Uma imagem vale mais que palavras e nos ajuda a entender melhor.")),
                            React.createElement(PhotoButton, { type: "button", variant: "primary", outlined: true, onClick: handleAddImageClick }, file ? 'Trocar foto' : 'Adicionar foto')),
                        React.createElement(HiddenFileInput, { ref: fileInputRef, type: "file", accept: "image/*", onChange: handleImageChange }),
                        file && (React.createElement(PhotoPreview, null,
                            React.createElement("img", { src: file, alt: "Foto anexada" }),
                            React.createElement(IconButton, { style: { color: '#A30000', fontSize: '20px' }, onClick: function () { return handleDeleteImageClick(); } },
                                React.createElement(AiFillDelete, null)))),
                        React.createElement(SectionDivider, null),
                        React.createElement(OptionRow, null,
                            React.createElement(OptionIcon, null,
                                React.createElement(BsEnvelope, { size: 20 })),
                            React.createElement(OptionText, null,
                                React.createElement(OptionTitle, null, "Quero receber um retorno"),
                                React.createElement(OptionDescription, null, "Podemos entrar em contato sobre sua opini\u00E3o.")),
                            React.createElement(Switch, { onChange: function () { return setUserInfoFilled(function (old) { return !old; }); }, checked: isUserInfoFilled })),
                        isUserInfoFilled && (React.createElement(ContactFields, null,
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Field, { type: "text", name: "nome", className: "theme-color-input", style: { width: '100%' }, placeholder: 'Nome' }),
                                    React.createElement(StyledErrorMessageWrapper, null,
                                        React.createElement(ErrorMessage, { name: "nome" })))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(TextField, { placeholder: 'Telefone', variant: "cel-phone", name: "telefone", className: "theme-color-input", style: { width: '100%' }, onValueChange: function (value) {
                                            setFieldValue('telefone', value);
                                        } }),
                                    React.createElement(StyledErrorMessageWrapper, null,
                                        React.createElement("div", null, errors.telefone)))),
                            React.createElement(Row, null,
                                React.createElement(Col, { xs: 12 },
                                    React.createElement(Field, { type: "email", name: "email", className: "theme-color-input", style: { width: '100%' }, placeholder: 'Email' }),
                                    React.createElement(StyledErrorMessageWrapper, null,
                                        React.createElement(ErrorMessage, { name: "email" })))),
                            React.createElement(ConsentCheckbox, null,
                                React.createElement(CheckboxField, { id: "i_accept_check", checked: lgpd, onValueChange: function (checkboxId, newValue) {
                                        setLgpd(newValue);
                                    } },
                                    "Li e aceito o",
                                    ' ',
                                    React.createElement("a", { href: "https://docs.google.com/document/d/1WwcGwRo3MKRs3BN5bsddaGdnaasmqa8QIrMiJIiisKs/edit?usp=drivesdk", target: "_blank", rel: "noopener noreferrer" }, "Termo de Consentimento para Coleta e Uso de Dados Pessoais"))))),
                        React.createElement(SubmitButton, { type: "submit", variant: "primary", disabled: isLoading || !realizouAvaliacao || commentHasError },
                            React.createElement(SubmitContent, null,
                                isLoading ? 'Enviando...' : 'Enviar minha opinião',
                                !isLoading && React.createElement(BsArrowRight, { size: 20 }))),
                        React.createElement(NpsFooter, null,
                            !isUserInfoFilled && (React.createElement(FooterLine, null,
                                React.createElement(BsLockFill, null),
                                " Sua opini\u00E3o \u00E9 an\u00F4nima e segura.")),
                            React.createElement(FooterLine, null,
                                React.createElement(BrandDots, { "aria-hidden": "true" }),
                                " Juntos por uma experi\u00EAncia melhor."))));
                })))));
};
